/** Typed DOM helpers are shared across games; see @jpj/game-shell. */
import { $ } from "@jpj/game-shell";
export { $ } from "@jpj/game-shell";

/* Frequently used elements, cached once (module scripts run after parse). */
export const boardEl = $("questBoard");
export const benchEl = $("bench");
